import React from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux'
import H1 from "../../Components/H1";
import {ToolbarWithLogo} from '../../Components/Toolbar';
import ContainerPage, {PICK_SERVICES_PATH, Routes} from "../ContainerPage";
import {BottomWrapper, CoreWrapper, TopWrapper} from '../../Components/Layout';
import PoweredBy from "../../Components/PoweredBy";
import ProgressTracker from "../../Components/ProgressTracker";
import Toast from "../../Components/Toast";
import H2 from "../../Components/H2";
import styled from "styled-components";

import {
    CenterContainer, ColumnFlexContainer,
    TextContainer,
} from "./CommonUI";
import {validateCode, createCustomer, replaceToken, resendValidatePhone} from "./Actions";
import FullPageLoader from "../../Components/FullPageLoader";
import {Button} from "rmwc/Button/index";
import Sizes from "../../Assets/Sizes";
import {getSafely, isNonEmptyObject, isNonEmptyString, valueOrDefault} from "@tomeravni/easybizy-js-common/common";
import SingleLineInput from "../../Components/SingleLineInput";
import InputWithLabel from "../../Components/InputWithLabel";
import Expandable from "../../Components/ExpandableComponent";
import {
    validateAdaptEmail,
    validateAdaptIdentifyNumber,
    validateAdaptMinLength,
    validateAdaptPhoneNumber
} from "../../Common/validation";
import NavigationButton from "../../Components/NavigationButton";

const SendAnotherContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${Sizes.defaultPadding};

    p {
        color: ${p => p.theme.colors.primaryText};
    }
`;

const SecondaryButton = styled(Button).attrs({
    className: 'existing-meetings-dialog__secondary-button',
})`
    --mdc-theme-primary: ${p => p.theme.colors.primaryText};

    height: auto;
    padding-top: ${Sizes.smallMargin};
    padding-bottom: ${Sizes.smallMargin};
    border-radius: ${Sizes.defaultBorderRadius};
    font-family: inherit;
    border: none;
    font-weight: 400;
    color: ${p => p.theme.colors.primaryText};
    text-decoration: underline;
`;

class Validate extends ContainerPage {
    state = {
        validationValue: '',
        showNotReceivedCode: false,
        sendingAnotherCode: false,
        fillOutMode: false,
        customerFieldsValidationState: {}
    };


    constructor(props) {
        super(props);
        this.allowAnonymous = true;
        this.nextRoute = Routes.pickServices;
        this.fieldRefs = {};
    }

    setFieldRef = (key) => (ref) => {
        if (ref) {
            this.fieldRefs[key] = ref;
        } else {
            delete this.fieldRefs[key];
        }
    };


    buildCustomerAdditionOrUpdate(requiredFields, optionalFields) {
        this.setState({
            requiredFields: requiredFields,
            optionalFields: optionalFields,
            fullNameMode: true,
            showNotReceivedCode: false
        }, () => {
            setTimeout(() => {
                let firstInputField = this.fieldRefs[this.customerInputFields[0]];
                if (firstInputField) {
                    firstInputField.focus()
                }
            }, 500)
        });

    }

    validate(value) {
        this.props.validateCode(value, this.props.config.Token, (err, res) => {
            const {requiredFields, optionalFields} = valueOrDefault(res, {});

            if (err) {
                this.showToastMessage(this.props.intl.formatMessage({id: err.message}));
            } else if (res.updatedToken) {
                /// Existing Customer, nothing to fill out.
                if (!isNonEmptyObject(requiredFields) && !isNonEmptyObject(optionalFields)) {
                    this.didNavigate = true;
                    this.props.replaceToken(res.updatedToken);
                    this.showToastMessage(this.props.intl.formatMessage({id: 'app.niceToMeetYou'}));
                    setTimeout(() => {
                        this.navigate(PICK_SERVICES_PATH, res.updatedToken)
                    }, 1500);
                } else {
                    this.buildCustomerAdditionOrUpdate(requiredFields, optionalFields);
                }


            } else {
                if (this.sendAnotherTimer) {
                    clearTimeout(this.sendAnotherTimer);
                    this.sendAnotherTimer = null;
                }

                if (!this.props.config.EnableNewCustomers) {
                    return this.fatalError('app.not_allowing_new_customers')
                }

                this.buildCustomerAdditionOrUpdate(requiredFields, optionalFields);
            }
        });
    }

    didNavigate = false;

    componentDidUpdate(prevProps) {
        if (
            !this.didNavigate &&
            this.props.config &&
            this.props.config.Customer &&
            (!prevProps.config || !prevProps.config.Customer)
        ) {
            this.didNavigate = true;
            this.startOver();
        }

        if (this.state.showNotReceivedCode && this.props.resentCode) {
            this.setState({showNotReceivedCode: false});
        }

        if (this.props.config && !this.metadata) {
            const fieldLabels = {
                fullName: this.props.intl.formatMessage({id: 'schedule.fullName'}),
                identifyNumber: this.props.intl.formatMessage({id: 'id_number'}),
                phoneNumber: this.props.intl.formatMessage({id: 'schedule.phoneNumber'}),
                email: this.props.intl.formatMessage({id: 'optional_input_email'})
            }

            const fieldPatterns = {
                fullName: undefined,
                identifyNumber: '[0-9]*',
                phoneNumber: '[0-9]*',
                email: undefined
            }

            const fieldInputType = {
                fullName: 'text',
                identifyNumber: 'tel',
                phoneNumber: 'tel',
                email: 'email'
            }

            const fieldAutoComplete = {
                fullName: 'name',
                identifyNumber: 'off',
                phoneNumber: 'tel',
                email: 'email'
            }


            const fieldValidators = {
                fullName: validateAdaptMinLength(2),
                identifyNumber: validateAdaptIdentifyNumber,
                phoneNumber: validateAdaptPhoneNumber,
                email: validateAdaptEmail(false)
            }

            const invalidMessages = {
                fullName: this.props.intl.formatMessage({id: 'invalid_full_name'}),
                identifyNumber: this.props.intl.formatMessage({id: 'invalid_identify_number'}),
                phoneNumber: this.props.intl.formatMessage({id: 'invalid_phone_number'}),
                email: this.props.intl.formatMessage({id: 'invalid_email'})
            }

            this.metadata = {
                fieldLabels,
                fieldPatterns,
                fieldValidators,
                invalidMessages,
                fieldInputType,
                fieldAutoComplete,
            }

        }
    }

    componentDidMount() {
        super.componentDidMount();
        setTimeout(() => {
            if (!this.props.validRoute) {
                this.loadPreviousRoute();
            }
        }, 500);

        this.sendAnotherTimer = setTimeout(() => {
            this.setState({
                showNotReceivedCode: true
            })
        }, 25000)
    }


    createCustomer() {
        const firstInvalid = Object.keys(this.state.customerFieldsValidationState).find((key) => !this.state.customerFieldsValidationState[key])
        if (firstInvalid) {
            this.showToastMessage(this.metadata.invalidMessages[firstInvalid]);
            let firstField = this.fieldRefs[firstInvalid];
            if (firstField) {
                firstField.focus();
            }

            return;
        }

        this.pageLoader.load(this.props.intl.formatMessage({id: 'app.creating_customer'}));
        const {fullName, identifyNumber, phoneNumber, email} = this.state;

        this.props.createCustomer(this.props.config.Token, fullName, identifyNumber, phoneNumber, email, (err, res) => {
            if (err || !res.updatedToken) {
                this.pageLoader.error();
                this.showToastMessage(this.props.intl.formatMessage({id: err.message}));
            } else {
                this.didNavigate = true;
                this.pageLoader.done();
                this.props.replaceToken(res.updatedToken);
                setTimeout(() => {
                    this.navigate(PICK_SERVICES_PATH, res.updatedToken)
                }, 1500);
            }
        });
    }


    validateAdaptCode(currentValue) {
        return {
            isValid: currentValue.length > 4,
            adaptedValue: currentValue
        }
    }

    sendAnotherCode = () => {
        this.setState({
            sendingAnotherCode: true
        })

        this.props.resendValidateCode(this.props.config.Token, (err) => {
            this.showToastMessage(this.props.intl.formatMessage({id: getSafely(['message'], err, 'sent_again')}));
        })

    }

    updateField(fieldName, event) {
        let value = event.target.value;
        this.safeSetStateDiff({[fieldName]: value}, () => {
        });
    }

    updateValidity(fieldName, isValid) {
        this.setState((prevState) => ({
            customerFieldsValidationState: {
                ...prevState.customerFieldsValidationState,
                [fieldName]: isValid
            }
        }));
    }

    get isCreateCustomerButtonEnabled() {
        return valueOrDefault(this.state.requiredFields, []).every((key) => {
            return this.state.customerFieldsValidationState[key] || isNonEmptyString(this.state[key]);
        });
    }

    get hasValidationValue() {
        return isNonEmptyString(this.state.validationValue);
    }

    get customerInputFields() {
        return [].concat(valueOrDefault(this.state.requiredFields, [])).concat(valueOrDefault(this.state.optionalFields, []));
    }

    buildCustomerInputFields() {
        const fields = [];
        const inputFields = this.customerInputFields;

        const {
            fieldLabels,
            fieldPatterns,
            fieldValidators,
            fieldInputType,
            fieldAutoComplete,
        } = valueOrDefault(this.metadata, {});


        for (const fieldName of inputFields) {
            fields.push(
                <InputWithLabel
                    key={fieldName}
                    pattern={fieldPatterns[fieldName]}
                    inputType={fieldInputType[fieldName]}
                    autoComplete={fieldAutoComplete[fieldName]}
                    value={this.state[fieldName]}
                    ref={this.setFieldRef(fieldName)}
                    label={fieldLabels[fieldName]}
                    validateAdaptValue={fieldValidators[fieldName]}
                    validityStatusChange={this.updateValidity.bind(this, fieldName)}
                    onChange={this.updateField.bind(this, fieldName)}
                />
            );
        }

        return fields;
    }

    render() {
        const ltr = !this.props.intl.locale.includes('he');
        const toolbarLogo = getSafely(['theme', 'properties', 'avatarImage'], window) || (this.props.config && this.props.config.Logo) || '';
        const codeLabel = this.props.intl.formatMessage({id: 'schedule.verificationCode'});

        return (
            <div className="transition-item detail-page">
                <CoreWrapper padding={true} loading={!this.props.config || this.props.validating} ltr={ltr}>
                    <ToolbarWithLogo imageUri={toolbarLogo} ltr={ltr}
                                     rootUri={this.getRoutePrefix()}>
                        <ProgressTracker progress={this.props.progress} current={0} visible={true}/>

                    </ToolbarWithLogo>

                    <TopWrapper justify="start" align="start">
                        <CenterContainer>
                            <H2 center={true}><FormattedMessage id="schedule.identifyHeader"/>,</H2>
                            <H1><FormattedMessage id="schedule.letsMeet"/>&nbsp;<span role="img" aria-label="🙏">🙏</span></H1>
                        </CenterContainer>
                        <TextContainer>

                            <SingleLineInput inProgress={this.props.validating}
                                             disabled={this.state.fullNameMode}
                                             label={codeLabel}
                                             value={this.state.validationValue}
                                             onChange={this.updateField.bind(this, 'validationValue')}
                                             pattern={'[0-9]*'}
                                             autoComplete="one-time-code"
                                             onSubmit={(val) => this.validate(val)}
                                             validateAdaptValue={this.validateAdaptCode.bind(this)}
                                             isFocused={true}
                            />

                            <Expandable isExpanded={this.state.fullNameMode}>
                                <ColumnFlexContainer>
                                    {this.buildCustomerInputFields()}
                                </ColumnFlexContainer>
                                <NavigationButton
                                    disabled={this.props.creatingCustomer || !this.isCreateCustomerButtonEnabled}
                                    click={() => this.createCustomer()}><FormattedMessage
                                    id="schedule.next"/></NavigationButton>

                            </Expandable>
                            <Expandable isExpanded={this.state.showNotReceivedCode && !this.hasValidationValue}>
                                <SendAnotherContent>
                                    <p><FormattedMessage id="did_not_receive_code"/></p>
                                    <SecondaryButton
                                        disabled={this.state.sendingAnotherCode}
                                        onClick={() => this.sendAnotherCode()}><FormattedMessage
                                        id="send_again"/></SecondaryButton>
                                </SendAnotherContent>
                            </Expandable>
                        </TextContainer>
                        <BottomWrapper empty={true}>
                            <PoweredBy/>
                        </BottomWrapper>
                    </TopWrapper>
                </CoreWrapper>
                <FullPageLoader ref={r => this.pageLoader = r}/>
                <Toast ref={(toast) => this.toast = toast}/>
            </div>
        )
    }
}

/** Styled-Components **/

/** END OF Styled-Components **/

const mapStateToProps = state => {
    return {
        loading: state.schedule.fetchingConfig,
        config: state.schedule.config,
        progress: state.schedule.progress,
        validating: state.identify.validatingCode,
        codeValidated: state.identify.codeValidated,
        creatingCustomer: state.identify.creatingCustomer,
        updatedToken: state.identify.updatedToken,
        resentCode: state.identify.resentCode,
        requirePhone: !(state.schedule.stateParams && state.schedule.stateParams.mobile),
        validatedByEmail: !!(state.schedule.stateParams && state.schedule.stateParams.email),
        validRoute: (state.schedule.stateParams && (state.schedule.stateParams.mobile || state.schedule.stateParams.email) && state.schedule.stateParams.validation_hash)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        validateCode: (code, context, callback) => dispatch(validateCode(code, context, callback)),
        resendValidateCode: (token, callback) => dispatch(resendValidatePhone(token, callback)),
        createCustomer: (token, fullName, identifyNumber, phoneNumber, email, callback) => dispatch(createCustomer(token, fullName, identifyNumber, phoneNumber, email, callback)),
        replaceToken: (updatedToken) => dispatch(replaceToken(updatedToken)),

    }
};


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Validate));
